module.exports = __webpack_public_path__ + "img/haupt.1bf39b55.jpg";